import React, { Component } from "react";
// import ApolloClient from "apollo-boost";
// import { gql } from "apollo-boost";
import "./Project.css";
// import GithubRepoCard from "../../components/githubRepoCard/GithubRepoCard";
// import Button from "../../components/button/Button";
// import { openSource } from "../../portfolio";
// import { greeting } from "../../portfolio.js";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { projectsnew } from "../../portfolio";
import { Fade } from "react-reveal";

// export default function Projects() {
  // const [repo, setrepo] = useState([]);

  // useEffect(() => {
  //   getRepoData();
  // }, []);

  // function getRepoData() {
  //   const client = new ApolloClient({
  //     uri: "https://api.github.com/graphql",
  //     request: (operation) => {
  //       operation.setContext({
  //         headers: {
  //           authorization: `Bearer ${atob(openSource.githubConvertedToken)}`,
  //         },
  //       });
  //     },
  //   });

  //   client
  //     .query({
  //       query: gql`
  //         {
  //           repositoryOwner(login: "${openSource.githubUserName}") {
  //             ... on User {
  //               pinnedRepositories(first: 6) {
  //                 edges {
  //                   node {
  //                     nameWithOwner
  //                     description
  //                     forkCount
  //                     stargazers {
  //                       totalCount
  //                     }
  //                     url
  //                     id
  //                     diskUsage
  //                     primaryLanguage {
  //                       name
  //                       color
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       `,
  //     })
  //     .then((result) => {
  //       setrepoFunction(result.data.repositoryOwner.pinnedRepositories.edges);
  //       console.log(result);
  //     });
  // }

  // function setrepoFunction(array) {
  //   setrepo(array);
  // }

//   return (
//     <div className="main" id="educations">
//         <div className="educations-header-div">
//           <Fade bottom duration={2000} distance="20px">
//             <h1 className="educations-header" style={{ color: theme.text }}>
//               Projects
//             </h1>
//           </Fade>
//         </div>
//         <div className="educations-body-div">
//           {projectsnew.degrees.map((degree) => {
//             return <DegreeCard degree={degree} theme={theme} />;
//           })}
//         </div>
//     </div>
//   );
// }

class Project extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="main" id="educations">
        <div className="educations-header-div">
          <Fade bottom duration={2000} distance="20px">
            {/* <h1 className="educations-header" style={{ color: theme.text }}>
              Projects
            </h1> */}
          </Fade>
        </div>
        <div className="educations-body-div">
          {projectsnew.degrees.map((degree) => {
            return <DegreeCard degree={degree} theme={theme} />;
          })}
        </div>
      </div>
    );
  }
}

export default Project;

